import React, { useState } from "react";

import { useLazyQuery } from "../../hooks";
import { metaDefault } from "../../config/meta";
import { getString } from "../../utilities";
import { FormProvider, useForm } from "react-hook-form";
import RedemptionForm from "../global/RedemptionForm";
import { CHECK_PROMO_QUERY } from "../../graphql/queries";
import { useLocation, useNavigate } from "react-router";
import routeCodes from "../../config/routeCodes";
import { getSearchParamString } from "../../config";
import { validateGiftCardOrPromo } from "../../utilities/forms/rules";

export default function Promo() {
  const [submitErrors, setSubmitErrors] = useState(null);
  const [hasQueryCalled, setHasQueryCalled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { formState, handleSubmit, register, getValues } = useForm({
    mode: "onChange",
    defaultValues: { code: "" },
  });

  const onError = (error) => {
    setSubmitErrors(error);
    setHasQueryCalled(false);
  };

  const onCompleted = (data) => {
    navigate({
      pathname: routeCodes.SUBSCRIBE,
      search: `?${getSearchParamString("coupon")}=${data.checkPromo.shortname}`,
    });
  };

  const { executeQuery: checkPromo, loading: checkPromoLoading } = useLazyQuery(
    CHECK_PROMO_QUERY,
    onCompleted,
    onError,
  );

  const onSubmit = (data) => {
    setHasQueryCalled(true);
    checkPromo({ shortname: data.code });
  };

  return (
    <>
      {metaDefault({ path: location.pathname, title: getString("redeem.promo.title"), noCrawl: true })}

      <FormProvider handleSubmit={handleSubmit} formState={formState} register={register} getValues={getValues}>
        <RedemptionForm
          onSubmit={onSubmit}
          submitErrors={submitErrors}
          validationRules={{
            validate: (value) => validateGiftCardOrPromo(value) || getString("promo.errors.invalid"),
          }}
          isLoading={checkPromoLoading || hasQueryCalled}
          loadMessage={getString("promo.checking")}
          redeemCta={getString("redeem.code")}
          redeemLabel={getString("redeem.promo.label")}
          placeholder={getString("promo.claim.example")}
          buttonText={getString("redeem.button")}
          title={getString("redeem.promo.title")}
        />
      </FormProvider>
    </>
  );
}
